import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ProgramacionService } from 'app/main/wizard-cgo/services/programacion.service';
import { LeaderEditEmaService } from 'app/main/wizard-leader/services/leaderEditEma.service';
import { WizardService } from 'app/main/wizard-cgo/services/wizard.service';
import { fuseAnimations } from '@fuse/animations';
import * as catalogo from '../catalogo';
import * as backInter from 'app/auth/auth-data.model';
import Swal from 'sweetalert2';
import { lang_modales } from 'app/idiomas/i18n/modales/modales.lang';
import {TranslateService} from '@ngx-translate/core';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';


@Component({
  selector: 'correos',
  templateUrl: './correos.component.html',
  styleUrls: ['./correos.component.scss'],
  animations   : fuseAnimations
})
export class CorreosComponent implements OnInit {

  comunicacionEditor: any;
  @Input() actualizaEmail: Observable<any>;
  @Output() cambiaPaso: EventEmitter<number> = new EventEmitter();
  @Output() enviaDatosEditor: EventEmitter<any> = new EventEmitter();

  tipoCorreos = catalogo.tipoCorreos;

  // Datos certificar vigente
  productoActual: any;

  instituto: number;
  claveNativo: string;
  idiomas: any[] = [];
  idiomasGuardadosCertificar: any[] = [];
  tiposCorreos:any[] = [
    {tipo: 1}, //invitacon
    // {tipo: 2}, //recordatorio
    // {tipo: 3},  //aviso 1
    // {tipo: 4},  //aviso 2
    // {tipo: 5},  //cierre
    {tipo: 6},  //personalizados aún no inician
    {tipo: 7},  //personalizados inican pero aún no acaban
  ];

  generalCorreosLeader:any[]=[];

  constructor(
    private programacionService: ProgramacionService,
    private leaderService: LeaderEditEmaService,
    private wizardService: WizardService,
    private translateSrv: TranslateService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
  ) {
    lang_modales.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
  }

  ngOnInit() {
    this.getInstituto();
    this.obtieneProductoActual();
    this.comunicacionEditor = this.actualizaEmail.subscribe( (datos) => {
      console.log("se envio datos desde componente editor: ",datos);
      // this.checkCorreosGuardados();
    });
  }

  obtieneProductoActual(){
    /// obtiene el producto certificar vigente
    this.programacionService.getProdCertAct().subscribe((data:backInter.infoProductos) => {
      // let productos:backInter.prodCert[] = data.productosCertificar;
      let productos: any[] = [];
      switch (localStorage.getItem('tipoProducto')) {
        case '1': case 'c1': case 'c3': case 'p1': case 'm7': case 'f1': case 'L1':
        productos = data.productosCertificar;
        break;
      }
      var BreakException = {};
      try {
        productos.forEach( (producto) => {
          let fecha = producto.fechaCertificar;
          let idProducto = producto.idCertificar;
          if(fecha == parseInt(localStorage.getItem('fechaProducto')) && idProducto == localStorage.getItem('productoID')){
            this.productoActual = producto;
            throw BreakException;
          }
        });
      } catch (e) {
        if (e !== BreakException) throw e;
      };
      this.getIdiomasCerActioAsociado();
    }, error  => {
      console.log("error al recuperar certificar vigente");
    });
  }

  getIdiomasCerActioAsociado(){
    this.leaderService.getIdiomasCerActioAsoc(this.productoActual.asociadoId).subscribe( (data: any) => {
      console.log('***************************',data);
      this.idiomasGuardadosCertificar=data.records;
      let arregloIdiomas:any[]=[];
      this.idiomasGuardadosCertificar.forEach(idioma => {
        let splitIdioma= idioma.Native.split('-');
        // lider.native=splitIdioma[0];
          idioma.Native=splitIdioma[0];
        arregloIdiomas.push(splitIdioma[0]);
        // if (idioma.Native=="es-Español") {
        //   idioma.Native='es';
        //   arregloIdiomas.push('es');
        // }else if(idioma.Native=="pt-Portugués"){
        //   idioma.Native='pt';
        //   arregloIdiomas.push('pt');
        // }else if(idioma.Native=="en-Ingles"){
        //   idioma.Native='en';
        //   arregloIdiomas.push('en');
        // }
      });
      console.log('idiomasGuardadosCertificar',this.idiomasGuardadosCertificar);
      console.log('arregloIdiomas',arregloIdiomas);
      this.tiposCorreos.forEach((tipoCorreo, i) => {
        let arrIdiomas:any[] = [];
        this.idiomasGuardadosCertificar.forEach(idioma => {
            let objIdiomas:any = {};
            objIdiomas.idioma = idioma.Native;
            objIdiomas.guardado = false;
            objIdiomas.html = '';
            objIdiomas.asunto = '';
            objIdiomas.piloto = '';
            arrIdiomas.push(objIdiomas);
        });
        tipoCorreo.idiomas = arrIdiomas;
      });

      this.getTemplateEmailEmpres(arregloIdiomas);
      });
    }

  getTemplateEmailEmpres(arregloIdiomas){
    this.leaderService.getTemplateEmailEmpresa(localStorage.getItem('productoID')).subscribe( (data: any) => {
      console.log('***************************',data);
      this.generalCorreosLeader=data.generalCorreos;
      if (this.generalCorreosLeader.length==0) {
        let datos={
          empresaId:localStorage.getItem('companyID'),
          productoId:localStorage.getItem('productoID'),
          idiomas:arregloIdiomas
        }
        this.leaderService.saveTemplateEmailLea(datos).subscribe( (data1: any) => {
          console.log('**Se guardaron por primera vez ',data1);
   this.getTemplateEmailEmpres([]);
        });
      }else{
        this.generalCorreosLeader.forEach(correo => {
          let tipo=this.tiposCorreos.find(item=>item.tipo== correo.tipo);
          if (tipo!=undefined) {
            let idiomaCorreo= tipo.idiomas.find(item=>item.idioma== correo.idioma)
            if (idiomaCorreo!=undefined) {

                idiomaCorreo.asunto= correo.asunto;
                idiomaCorreo.guardado= true;
                idiomaCorreo.html= correo.correo;
                idiomaCorreo.idioma= correo.idioma;
                idiomaCorreo.piloto= correo.piloto;
            }
          }

        });

      }


        // let idx = data1.generalCorreos.findIndex(item => item.tipo === this.tiposCorreos[indice].tipo && item.idioma == idiomaCo.idioma);
        // console.log("tipo:",tipoCorreo.tipo," idioma:",idiomaCo.idioma," idx:",idx);
        // if(idx != -1){
        //   this.tiposCorreos[indice].idiomas[i].guardado = true;
        //   this.tiposCorreos[indice].idiomas[i].html = data1.generalCorreos[idx].correo;
        //   this.tiposCorreos[indice].idiomas[i].asunto = data1.generalCorreos[idx].asunto;
        //   this.tiposCorreos[indice].idiomas[i].piloto = data1.generalCorreos[idx].piloto;
        //
        //   let todosGuardados = true;
        //   this.tiposCorreos.forEach(tipoCorreo => {
        //     tipoCorreo.idiomas.forEach(idiomaTipoCo => {
        //       if(!idiomaTipoCo.guardado){
        //         todosGuardados = false;
        //       }
        //     });
        //   });
        //   if(todosGuardados)
        //   console.log("todos los correos se encontraron guardados :v ",this.tiposCorreos);
        // }
        // else{
        //
        //   let datos: any = {
        //     tipo: tipoCorreo.tipo,                       //1=invitacion, 2=recordatorio
        //     idProducto,                 //clave del producto, 1=certificar, 2=medirv1,... etc
        //     productoId: localStorage.getItem('productoID')
        //   };
        //   this.getTemplateBase(datos, indice, idiomaCo.idioma);
        //
        // }


      });
    }

    getInstituto(){
      switch(this.wizardService.getInstituto()){
        case '1': case 'MX': this.instituto = 1; break;
        case '2': case 'CAyC': this.instituto = 2; break;
        case '3': case 'HK': this.instituto = 3; break;
        case '4': case 'SGP': this.instituto = 4; break;
        case '5': case 'TK': this.instituto = 5; break;
        case '6': case 'FL': this.instituto = 6; break;
        case '11': case 'BR': this.instituto = 11; break;
        case '14': case 'GCTI': this.instituto = 14; break;
        case '15': case 'ES': this.instituto = 15; break;
      }
      if(this.instituto != 1 && this.instituto != 2 && this.instituto != 11 && this.instituto != 14){  //parche temporal para que no se creen avisos fuera de mx o br
        this.tiposCorreos.splice(1,2);  //comienza en pos 1, elimina 2
        this.tipoCorreos[0].activo = false;
      }
    }

    checkCorreosGuardados(){
      let idProducto = 0;
      switch (localStorage.getItem('tipoProducto')) {
        case '1': case 'c1': case 'c3': case 'p1': case 'm7': case 'f1': case 'L1':
        idProducto = 1;
        break;
      }

      this.tiposCorreos.forEach((tipoCorreo, i) => {
        let arrIdiomas:any[] = [];
        this.idiomas.forEach(idioma => {
          if(idioma.tipoIdioma != "3"){
            let objIdiomas:any = {};
            objIdiomas.idioma = idioma.nombreIdioma;
            objIdiomas.guardado = false;
            objIdiomas.html = '';
            objIdiomas.asunto = '';
            objIdiomas.piloto = '';
            arrIdiomas.push(objIdiomas);
          }
        });
        tipoCorreo.idiomas = arrIdiomas;
        this.getTemplateGuardado(tipoCorreo, idProducto, i);
      });
      console.log("tiposCorreos:",this.tiposCorreos);

    }

    getTemplateGuardado(tipoCorreo:any, idProducto:number, indice:number){
      let datos: any = {
        productoId: localStorage.getItem('productoID')
      }
      this.programacionService.empresaTemplate(datos).subscribe((respuesta:any) => {
        console.log("respGetTempEmpresa:",respuesta);

        tipoCorreo.idiomas.forEach((idiomaCo,i) => {
          let idx = respuesta.generalCorreos.findIndex(item => item.tipo === this.tiposCorreos[indice].tipo && item.idioma == idiomaCo.idioma);
          console.log("tipo:",tipoCorreo.tipo," idioma:",idiomaCo.idioma," idx:",idx);
          if(idx != -1){
            this.tiposCorreos[indice].idiomas[i].guardado = true;
            this.tiposCorreos[indice].idiomas[i].html = respuesta.generalCorreos[idx].correo;
            this.tiposCorreos[indice].idiomas[i].asunto = respuesta.generalCorreos[idx].asunto;
            this.tiposCorreos[indice].idiomas[i].piloto = respuesta.generalCorreos[idx].piloto;

            let todosGuardados = true;
            this.tiposCorreos.forEach(tipoCorreo => {
              tipoCorreo.idiomas.forEach(idiomaTipoCo => {
                if(!idiomaTipoCo.guardado){
                  todosGuardados = false;
                }
              });
            });
            if(todosGuardados)
            console.log("todos los correos se encontraron guardados :v ",this.tiposCorreos);
          }
          else{

            let datos: any = {
              tipo: tipoCorreo.tipo,                       //1=invitacion, 2=recordatorio
              idProducto,                 //clave del producto, 1=certificar, 2=medirv1,... etc
              productoId: localStorage.getItem('productoID')
            };
            this.getTemplateBase(datos, indice, idiomaCo.idioma);

          }
        });

      });
    }

    getTemplateBase(datos:any, indice:number, idioma:string){
      console.log("entro get templatebase:",indice);
      this.programacionService.getTemplate(datos).subscribe((respuesta:any) => {
        console.log("respGetTempBase:",respuesta);
        if (respuesta.message == "Success") {
          let idxCorr = this.tiposCorreos[indice].idiomas.findIndex(item => item.idioma == idioma);
          let idxHTML = respuesta.correosIdiomas.findIndex(item => item.idioma === idioma);
          if(idxHTML != -1){
            this.tiposCorreos[indice].idiomas[idxCorr].html = respuesta.correosIdiomas[idxHTML].correo;
            this.tiposCorreos[indice].idiomas[idxCorr].asunto = respuesta.correosIdiomas[idxHTML].asunto;
            this.tiposCorreos[indice].idiomas[idxCorr].piloto = respuesta.correosIdiomas[idxHTML].piloto;
            this.guardaCorreosPrimeraVez(indice, datos.tipo, this.tiposCorreos[indice].idiomas[idxCorr].html, this.tiposCorreos[indice].idiomas[idxCorr].asunto, this.tiposCorreos[indice].idiomas[idxCorr].piloto, idioma, idxCorr);
          }
          console.log("tiposCorreosAfetr:",this.tiposCorreos);
        }
      });
    }

    guardaCorreosPrimeraVez(indice:number, tipo:number, html:string, asunto:string, piloto:string, idioma:string, indiceIdioma:number){
      console.log("entro guardacorreos1avez:",indice);

      let datos: any = {
        productoId: localStorage.getItem('productoID'),
        tipo,
        html,
        asunto,
        piloto,
        idioma
      };
      console.log("guardaCorreo:",datos);

      this.programacionService.saveTemplate(datos).subscribe( (respuesta:any) => {
        if(respuesta.success){
          this.tiposCorreos[indice].idiomas[indiceIdioma].guardado = true;

          let todosGuardados = true;
          this.tiposCorreos.forEach((tipoCorreo, i) => {
            tipoCorreo.idiomas.forEach(idiomaTipoCo => {
              if(!idiomaTipoCo.guardado){
                todosGuardados = false;
              }
            });
          });
          if(todosGuardados){
            console.log("todos los correos ya se guardaron la primera vez alv :v ",this.tiposCorreos);
          }
        }
      });
    }

    irPaso(numPaso: number, tipoCorreo?: number){

      console.log("Num paso" +numPaso);
      console.log("Tipo "+tipoCorreo);
      console.log("this.instituto==14 "+this.instituto);
      if (tipoCorreo==3 && this.instituto==14|| tipoCorreo==4 && this.instituto==14||tipoCorreo==5 && this.instituto==14) {
        let text = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.PROGRAMACION.NOT_MESS_COM';
        let rspSi = 'MODALES.ACCIONES.aceptar';
        this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
        this.translateSrv.get(text).subscribe((res: string) => { text = res; });
        console.log("es correo de cierre de institutogcti");
        Swal.fire({
          title: text,
          icon: 'warning',
          confirmButtonText: rspSi,
          confirmButtonColor: '#e40601'
        });

      }else{
        this.cambiaPaso.emit(numPaso);
        if(tipoCorreo){
          this.enviaDatos(tipoCorreo);
        }

      }
    }

    enviaDatos(tipo:number){
      // let idProducto = 0;
      // let idPaquete = 0;
      // switch (localStorage.getItem('tipoProducto')) {
      //   case '1': case 'c1':
      //     idProducto = 1;
      //     idPaquete = 1
      //   break;
      // }
      // let datos: any = {
      //   tipo,                       //1=invitacion, 2=recordatorio
      //   idPaquete,                  //1 es certificar v1 y v2, 2 es nom good y better, 3 los medires, 4 pulse, 5 focus
      //   idProducto,                 //clave del producto, 1=certificar, 2=medirv1,... etc
      //   instituto: this.instituto,  //id instituto
      //   clave: this.claveNativo     //clave idioma
      // };
      let indice = this.tiposCorreos.findIndex(item => item.tipo == tipo);
      this.enviaDatosEditor.emit(this.tiposCorreos[indice]);
    }

  }
